'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import { useContext } from 'react';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { IsMobileContext } from './mobileUtils';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { useSelector } from 'react-redux';
import { isMon569VariantSelector } from '../../selectors/ExperimentTreatmentSelectors';
const BoldFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "AllPlansIncludeFooter__BoldFormattedMessage",
  componentId: "sc-1j92p6v-0"
})(["font-weight:bold;"]);
const Container = styled.div.withConfig({
  displayName: "AllPlansIncludeFooter__Container",
  componentId: "sc-1j92p6v-1"
})(["flex-direction:", ";", " ", ""], ({
  paidProductLevelsInGrid
}) => paidProductLevelsInGrid === 1 ? 'column' : 'row', breakpoint.sd(_t || (_t = _`
    flex-direction: ${0};
  `), ({
  isMon569Variant
}) => isMon569Variant ? 'column' : 'row'), breakpoint.tablet(_t2 || (_t2 = _`
    flex-direction: column;
  `)));

const CheckedItem = ({
  message,
  isMobile
}) => /*#__PURE__*/_jsxs("div", {
  className: isMobile ? 'm-top-1' : 'm-left-8',
  children: [/*#__PURE__*/_jsx(UIIcon, {
    name: "success"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    className: "m-left-2",
    message: message
  })]
});

const AllPlansIncludeFooter = ({
  productLevels,
  borderStyle
}) => {
  const isMon569Variant = useSelector(isMon569VariantSelector);
  const isMobile = useContext(IsMobileContext);
  const components = [];
  let paidColumnStart = 1;

  if (productLevels[0] === FREE && (isMon569Variant || !isMobile)) {
    paidColumnStart = 2;
    components.push( /*#__PURE__*/_jsx("div", {
      style: {
        borderRight: borderStyle,
        gridRowStart: 9,
        gridColumnStart: 1
      }
    }, FREE));
  }

  components.push( /*#__PURE__*/_jsxs(Container, {
    className: "justify-center align-center p-all-4",
    style: {
      msGridColumn: paidColumnStart,
      gridColumnStart: paidColumnStart,
      msGridColumnSpan: productLevels.length - paidColumnStart + 1,
      gridColumnEnd: `span ${productLevels.length - paidColumnStart + 1}`,
      msGridRow: 9,
      gridRowStart: 9,
      borderTop: borderStyle
    },
    isMon569Variant: isMon569Variant,
    paidProductLevelsInGrid: productLevels.filter(productLevel => productLevel !== FREE).length,
    children: [/*#__PURE__*/_jsx(BoldFormattedMessage, {
      message: "pricingPage.allPlansInclude"
    }), /*#__PURE__*/_jsx(CheckedItem, {
      message: "pricingPage.storageForContacts",
      isMobile: isMobile
    }), /*#__PURE__*/_jsx(CheckedItem, {
      message: "pricingPage.techSupport",
      isMobile: isMobile
    })]
  }, STARTER));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: components
  });
};

export default AllPlansIncludeFooter;